import { cva, type VariantProps } from 'class-variance-authority';
import type { ElementType, HTMLAttributes } from 'react';
import { cardSurface } from '../lib/card';
import { cn } from '../lib/cn';

const surface = cva('rounded-card', {
  variants: {
    tone: {
      // raised follows the card tokens: flat hairline for adults, building block for kids
      raised: cardSurface,
      sunken: 'bg-surface-sunken',
      outline: 'bg-surface-raised border border-border-subtle',
    },
    padding: { none: '', sm: 'p-inset-sm', md: 'p-inset-md', lg: 'p-inset-lg' },
  },
  defaultVariants: { tone: 'raised', padding: 'md' },
});

export interface SurfaceProps extends HTMLAttributes<HTMLElement>, VariantProps<typeof surface> {
  as?: ElementType;
}

/** Card-like container. Use `as="section"` / `as="article"` for landmarks and outline. */
export function Surface({ as: Tag = 'div', tone, padding, className, ...props }: SurfaceProps) {
  return <Tag {...props} className={cn(surface({ tone, padding }), className)} />;
}
